module.exports = __webpack_public_path__ + "static/flora-7b055b2bf3b463a08825d90f73b12290.jpg";